import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { FirebaseData } from '../../providers/firebase-data';
import { Utils } from '../../providers/utils';
import { OrderHistoryPage } from '../orders/order-history';
import { StoreListingPage } from './store-listing';

@Component({
  selector: 'page-orders',
  templateUrl: 'orders.html'
})
export class OrdersPage {
  public isLoading: boolean = true;
  public storeCategories: any;

  constructor(
    private nav: NavController, 
    private _fiData: FirebaseData, 
    private events: Events
    ) {
  }

  ionViewDidEnter() {
    let self = this;
    self.getStoreCats();
  }

  private getStoreCats(){
    var self = this;
    self.isLoading = true;
    self._fiData.get('store-category').subscribe(cats => {
      self.storeCategories = Utils.toArray(cats);
      self.isLoading = false;
    });
  }

  public goToPage(page){
  	if (page==='orderHistory'){
  		this.nav.push(OrderHistoryPage);
  	} else{
  		this.nav.push(StoreListingPage, {category: page});
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/orders.ts